import { render } from "./Onboarding.vue?vue&type=template&id=4006cacb&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=4006cacb&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4006cacb"],['__file',"src/components/Onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4006cacb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4006cacb', __exports__)) {
    console.log('reload')
    api.reload('4006cacb', __exports__)
  }
  
  module.hot.accept("./Onboarding.vue?vue&type=template&id=4006cacb&scoped=true", () => {
    console.log('re-render')
    api.rerender('4006cacb', render)
  })

}


export default __exports__